var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pb-2 rounded-lg",attrs:{"elevation":"0"}},[_c('div',{staticClass:"pa-4"},[_c('MessageLogsList',{attrs:{"global":""}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }